import routeArgsToInt from 'router/utils/routeArgsToInt';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import translation from 'translation';
import AdministrationNestedPage from 'layouts/nested/administration/AdministrationNestedPage';


const administrationRoutes = [
  {
    path: '/administration',
    name: 'administration',
    component: AdministrationNestedPage,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Administration')
      }
    },
    redirect: {name: 'adminUsersList'},
    children: [
      {
        path: 'collectstats',
        name: 'adminCollectStatisticsAndWebAnalytics',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Collect statistics and web analytics')
          }
        },
        component: wrapLegacyRoute('administrationController', 'collectStatisticsAndWebAnalytics'),
        props: routeArgsToInt
      },
      {
        path: 'billreport',
        name: 'adminBillReport',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Bill report')
          }
        },
        component: wrapLegacyRoute('administrationController', 'billReport'),
        props: routeArgsToInt
      },
      {
        path: 'billreportsnapshot',
        name: 'adminBillReportSnapshot',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Bill report snapshot')
          }
        },
        component: wrapLegacyRoute('administrationController', 'billReportSnapshot'),
        props: routeArgsToInt
      },
      {
        path: 'roles',
        component: NestedRouteComponent,
        meta: {
          nestedName: 'adminRoles_nested',
          routeName: {
            segmentName: () => translation.tr('Roles')
          }
        },
        children: [
          {
            path: '',
            name: 'adminRolesList',
            component: wrapLegacyRoute('administrationController', 'roleList'),
            props: routeArgsToInt
          },
          {
            path: ':roleId(\\d+)',
            name: 'adminRolesSettings',
            component: wrapLegacyRoute('administrationController', 'roleSettings')
          }
        ]
      },
      {
        path: 'users',
        name: 'adminUsersList',
        meta: {
          routeName: {
            segmentName: () => translation.tr('Users')
          }
        },
        component: wrapLegacyRoute('administrationController', 'userList'),
        props: routeArgsToInt
      }
    ]
  }
];

export default administrationRoutes;
